// Note: Helper functions
// Helper functions to warn, error and log messages to the console
export const logIt = (args = [], type = 'log') => { console && console[type] && console[type](...args) }; // eslint-disable-line
export const _warn = (...args) => logIt(args, 'warn');
export const _error = (...args) => logIt(args, 'error');
export const _log = (...args) => logIt(args, 'log');
export const isOfType = (val, type) => (
	Object.prototype.toString.apply(val).split(' ')[1].slice(0, -1).toLowerCase() === type.toLowerCase()
);
